
export default function ContactCTA() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Creative%20team%20brainstorming%20session%20in%20modern%20agency%20office%20diverse%20professionals%20collaborating%20around%20large%20table%20with%20mood%20boards%20brand%20designs%20warm%20ambient%20lighting%20contemporary%20workspace%20Kampala%20Uganda%20East%20African%20creative%20professionals%20working%20together%20cinematic%20photography%20warm%20teal%20and%20orange%20tones&width=1400&height=500&seq=contact-cta-bg-001&orientation=landscape"
            alt="Asili Visuals Team"
            className="w-full h-full object-cover object-top absolute inset-0"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D]/90 via-[#0D0D0D]/80 to-[#0D0D0D]/60"></div>

          <div className="relative z-10 py-14 sm:py-20 px-6 sm:px-10 lg:px-16 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left max-w-xl">
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
                Ready to Elevate Your Brand?
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed">
                From concept to execution, our team delivers integrated solutions that drive real results across East Africa. Let&apos;s build something extraordinary together.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="https://wa.me/256770000000"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group px-7 py-3.5 bg-[#25D366] text-white text-sm font-bold rounded-full hover:bg-[#1da851] transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                <span>Chat on WhatsApp</span>
              </a>
              <a
                href="tel:+256393103781"
                className="group px-7 py-3.5 border-2 border-white/30 text-white text-sm font-bold rounded-full hover:bg-white/10 hover:border-white/50 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>Call Us Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
